import { offerSelectedTier } from 'fym-shared/src/music24/watermarkUpsell';
import type { Music24PlanId } from '../../config/music24StripePlans';
import { useWatermarkSummary } from '../useWatermarkSummary';

/**
 * The plan that the watermark offer selects first (design: trial-upsell b4): Artist, or Pro when a
 * watermarked file needs it (`offerSelectedTier`). Null for every other prompt.
 */
export function useWatermarkOfferPlan(isWatermark: boolean): Music24PlanId | null {
  const { summary } = useWatermarkSummary();
  return isWatermark ? offerSelectedTier(summary) : null;
}
